import React from 'react';
import { useTranslation } from '../../i18n';
import { avatars } from '../../assets/avatars';

interface AvatarSelectorProps {
  selectedAvatar: string;
  onSelect: (avatar: string) => void;
  disabled?: boolean;
  label?: string;
  gridColumns?: number;
}

export const AvatarSelector: React.FC<AvatarSelectorProps> = ({
  selectedAvatar,
  onSelect,
  disabled = false,
  label,
  gridColumns = 4,
}) => {
  const { t } = useTranslation();
  const displayLabel = label ?? t('common.chooseYourAvatar');

  return (
    <>
      <label className="form-label form-label--spaced join-room-label" style={{
        marginBottom: '0.8rem',
        textAlign: 'center',
      }}>
        {displayLabel}
      </label>
      <div className="avatar-grid" style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${gridColumns}, 1fr)`,
        gap: '0.8rem',
        marginBottom: '1.5rem',
      }}>
        {avatars.map((avatar, index) => (
          <button
            key={index}
            className="avatar-button"
            onClick={() => onSelect(avatar)}
            disabled={disabled}
            style={{
              width: '100%',
              aspectRatio: '1',
              backgroundColor: selectedAvatar === avatar
                ? 'rgba(var(--color-primary-rgb), 0.3)'
                : 'rgba(248, 250, 252, 0.1)',
              border: selectedAvatar === avatar
                ? '3px solid var(--color-primary)'
                : '2px solid rgba(248, 250, 252, 0.3)',
              borderRadius: '12px',
              cursor: disabled ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              opacity: disabled ? 0.5 : 1,
              padding: '0.6rem',
            }}
            onMouseEnter={(e) => {
              if (!disabled && selectedAvatar !== avatar) {
                e.currentTarget.style.backgroundColor = 'rgba(248, 250, 252, 0.15)';
                e.currentTarget.style.borderColor = 'rgba(248, 250, 252, 0.5)';
              }
            }}
            onMouseLeave={(e) => {
              if (selectedAvatar !== avatar) {
                e.currentTarget.style.backgroundColor = 'rgba(248, 250, 252, 0.1)';
                e.currentTarget.style.borderColor = 'rgba(248, 250, 252, 0.3)';
              }
            }}
          >
            <img 
              src={avatar} 
              alt={`Avatar ${index + 1}`}
              style={{
                width: '92%',
                height: '92%',
                objectFit: 'contain',
              }}
            />
          </button>
        ))}
      </div>
    </>
  );
};
